<template>
  <div class="wrap">
    <div class="wrapContent img">
      <img src="@/assets/image/logo.png" alt="" @click="()=> $router.push({ name: 'Riches' })">
    </div>
    <div class="wrapContent nav">
      <div class="items">
        <div class="item" :class="{ act : act == '/index' }" @click="handleClick('/index')">
          {{pc_lang.Home}}
        </div>
        <div class="item" :class="{ act : act == '/riches' }" @click="handleClick('/riches')">
          {{pc_lang.My_Credit}}
        </div>
        <div class="item" :class="{ act : act == '/transactions' }" @click="handleClick('/transactions')">
          {{pc_lang.Transaction_Records2}}
        </div>
        <!-- <div class="item" :class="{ act : act == '/a' }" @click="handleClick('/a')">
          {{pc_lang.Merchant_Center}}
        </div>
        <div class="item" :class="{ act : act == '/a' }" @click="handleClick('/a')">
          {{pc_lang.Opened_platform}}
        </div>
        <div class="item" :class="{ act : act == '/a' }" @click="handleClick('/a')">
          {{pc_lang.Help_center}}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data(){
    return {
      /*list: [
        {
          title: '首页',
          route: '/index'
        },
        {
          title: '财富中心',
          route: '/riches'
        },
        {
          title: '交易记录',
          route: '/transactions'
        },
        {
          title: '商户中心',
          route: '/a'
        },
        {
          title: '开放平台',
          route: '/a'
        },
        {
          title: '帮助中心',
          route: '/a'
        }
      ],*/
      act: '',
    }
  },
  computed: {

  },
  async mounted() {

  },
  created() {
    this.act = this.$route.path
  },
  methods: {
    handleClick(item) {
      this.$router.push({ path: item})
    }
  },
  watch: {
    '$route.path'(val, oldVal) {
      this.act = val
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap{
  background: #fff;
  padding-bottom: 10px;
  overflow: hidden;
  .wrapContent{
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    &.img{
      padding: 4px 0;
      img{
        max-height: 80px;
      }
    }
    &.nav{
      background: $blue;
      border-radius: 6px;
    }
    .items{
      height: 100%;
      font-size: 16px;
      .item{
        display: inline-flex;
        height: 100%;
        align-items: center;
        padding: 10px 20px;
        cursor: pointer;
        @extend .transition;
        font-size: 16px;
        color: #fff;
        &.act{
          color: darken($blue, 30%);
        }
        &:hover{
          // color: darken($blue, 30%);
          background: darken($blue, 10%);
          @extend .transition;
        }
      }
    }
  }
}
</style>